import { toast } from "react-toastify";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { useEffect, useRef } from "react";
import { _single, _WorkActivityNotes } from "../../../../core/services/dataBean/EntityCatalog";
import { BasicButton } from "../../../theme/Component/BasicButton";

type WorkActivity = {
    IDWorkActivity: number;
    [key: string]: any;
}

interface Props {
    WorkActivity: WorkActivity;
    canUse?: boolean;
}

export const WorkActivityNotes = ({ WorkActivity, canUse }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_WorkActivityNotes);
    const bottomRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (WorkActivity.IDWorkActivity) {
            getLista();
        }
        setBean({
            IDWorkActivity: WorkActivity.IDWorkActivity,
            State: 1,
            IDEmployee: _single.getAccountID(),
            Message: "",
            NoteName: ""
        })
    }, [WorkActivity])

    useEffect(() => {
        bottomRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [lista]);

    const getLista = () => {
        const props = {
            IDWorkActivity: WorkActivity.IDWorkActivity,
            State: 1
        }
        instance.getWorkActivityNotesRender(null, null, props)
            .then((resp) => setLista(resp.List))
            .catch(err => toast.error(err))
    }

    const addNote = () => {
        if (!bean.NoteName || !bean.Message) {
            toast.warning("Debes ingresar título y mensaje");
            return;
        }

        instance.updateWorkActivityNotes(bean)
            .then(() => {
                setBean({ ...bean, Message: "", NoteName: "" });
                getLista();
            })
            .catch(() => toast.error("No se pudo realizar la Acción"))
    }

    return (
        <div className="row" style={{ maxHeight: `66vh` }}>

            {/* LISTA */}
            <div className="col-md-12 overflow-auto" style={{ height: `${canUse ? "70%" : "100%"}` }}>
                {Array.isArray(lista) && lista.length > 0 ? (
                    lista.map((Obs, index) => {
                        const Note = Obs.DataBeanProperties;
                        const isMine = Note.IDEmployee == _single.getAccountID();

                        return (
                            <div
                                key={index}
                                className={`d-flex mb-3 ${isMine ? "justify-content-end" : "justify-content-start"}`}
                            >
                                <div
                                    className="p-3 shadow-sm"
                                    style={{
                                        maxWidth: "75%",
                                        borderRadius: "16px",
                                        background: isMine ? "#dbeafe" : "#f1f5f9"
                                    }}
                                >
                                    {/* HEADER */}
                                    <div className="mb-1">
                                        <strong>{Note.AccountFullName}</strong>
                                    </div>

                                    {/* NOTE NAME */}
                                    {Note.NoteName && (
                                        <div className="mb-1 text-primary fw-semibold">
                                            {Note.NoteName}
                                        </div>
                                    )}

                                    {/* MESSAGE */}
                                    <div className="mb-2">
                                        {Note.Message}
                                    </div>

                                    {/* DATE */}
                                    <small className="text-muted">
                                        {Note.Since}
                                    </small>
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <div className="text-center py-4">
                        <p className="text-muted">No hay notas registradas</p>
                    </div>
                )}

                <div ref={bottomRef} />
            </div>

            {/* INPUT */}
            {canUse &&
                <div className="col-md-12 mt-2">
                    <hr />

                    <div className="mb-2">
                        <input
                            className="form-control"
                            placeholder="Título de la nota (ej: Validación filtros)"
                            value={bean.NoteName || ""}
                            onChange={(e) => setBean({ ...bean, NoteName: e.target.value })}
                        />
                    </div>

                    <div className="mb-2">
                        <textarea
                            className="form-control"
                            rows={3}
                            placeholder="Escribe el detalle de la nota..."
                            value={bean.Message || ""}
                            onChange={(e) => setBean({ ...bean, Message: e.target.value })}
                            style={{ resize: "none" }}
                        />
                    </div>

                    <div className="d-flex justify-content-end">
                        <BasicButton
                            eventClick={addNote}
                            icon="ri-add-line"
                        >
                            Agregar nota
                        </BasicButton>
                    </div>
                </div>
            }
        </div>
    )
}